import { ApolloLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import {
  clearAuth,
  currentCountryVar,
  currentShopIdVar,
  currentTokenVar,
} from "_graphql/cache/auth";

const authMiddleware = new ApolloLink((operation, forward) => {
  // check if token has been cached
  let authorization = currentTokenVar();
  let country = currentCountryVar();
  let shopId = currentShopIdVar();
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...(authorization ? { authorization: `Bearer ${authorization}` } : {}),
      country: country,
      // source: "store-front",
      source: "supplier-console",
      ...(shopId ? { "x-shop-id": shopId } : {}),
    },
  }));

  return forward(operation);
});

const resetAuthMiddleware = onError(({ networkError }) => {
  if (networkError) {
    if (networkError.name === "ServerError") {
      (networkError as any)?.result?.errors?.forEach(
        (error: { extensions: { code: string } }) => {
          if (error?.extensions?.code === "UNAUTHENTICATED") {
            clearAuth();
            return;
          }
        }
      );
    }
  }
});

export default authMiddleware.concat(resetAuthMiddleware);
